const INITIAL_STATE = { lots: [], deliveredLots: [] };

const setLotsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_LOTS":
      return { ...state, lots: [...action.payload] };
    case "GET_ALL_DELIVERED_LOTS":
      return { ...state, deliveredLots: [...action.payload] };
    case "UPLOAD_LOT":
      return {
        ...state,
        lots: action.payload
          ? [action.payload, ...state.lots]
          : [...state.lots],
      };
    case "UPDATE_LOT":
      const filteredLot = state.lots.filter(
        (lot) => lot.lotNo !== action.payload.lotNo
      );
      return { ...state, lots: [action.payload, ...filteredLot] };
    case "DELETE_LOT":
      const updatedLotsArray = state.lots.filter(
        (lot) => lot.lotNo !== action.payload
      );
      return { ...state, lots: updatedLotsArray };
    default:
      return { ...state };
  }
};
export default setLotsReducer;
